import clsx from 'clsx'

type GapingType =
  | 'Footer/Spacing/main-to-tagline'
  | 'Header/Spacing/space-between-vertical'
  | 'Footer/Spacing/logo-to-main'
  | 'Footer/Spacing/space-between-columns'
  | 'Footer/Spacing/space-between-buttons'
  | 'Header/Spacing/header-to-content'
  | 'Header/Spacing/space-between-horizontal'
  | 'Bento/Spacing/space-between'
  | 'Navigation Bar/Spacing/space-between-buttons'
  | 'Bento/Spacing/title-to-description'
  | 'Carousel/space-between'

type PaddingType =
  | 'Footer/Spacing/padding'
  | 'Breakpoints/top-bot-padding'
  | 'Breakpoints/side-padding'
  | 'Header/Spacing/top-bot'
  | 'Header/Spacing/icon-no'
  | 'Button/Spacing/top-bot'
  | 'Button/Spacing/left-right'
  | 'Bento/Spacing/padding-S'
  | 'Header/Spacing/top-bot-t'
  | 'Header/Spacing/top-bot-b'
  | 'Header/Spacing/top-bot120-b'
  | 'Header/Spacing/left-right'
  | 'Header/Spacing/left-right-r'
  | 'Header/Spacing/left-right-l'
  | 'Header/Spacing/icon-left'
  | 'Header/Spacing/icon-left-l'
  | 'Header/Spacing/icon-left-r'
  | 'Tabs/Spacing/Tab/top-bot'
  | 'Tabs/Spacing/Tab/left-right'
  | 'Tabs/Spacing/Bar/top-bot'
  | 'Tabs/Spacing/Bar/top-bot3'
  | 'Tabs/Spacing/Bar/left-right'
  | 'Tabs/Spacing/Bar/left-right48'
  | 'Bento/Spacing/padding-M'

export const gapping = (name: GapingType) => {
  switch (name) {
    case 'Footer/Spacing/main-to-tagline':
      return clsx(
        'gap-[40px]', // mobile
        'sm:gap-[32px]', // tablet
        'md:gap-[32px]' // desktop
      )
    case 'Header/Spacing/space-between-vertical':
      return clsx(
        'gap-[6px]', // mobile
        'sm:gap-[8px]', // tablet
        'md:gap-[12px]' // desktop
      )
    case 'Footer/Spacing/logo-to-main':
      return clsx(
        'gap-[16px]', // mobile
        'sm:gap-[32px]', // tablet
        'md:gap-[24px]' // desktop
      )
    case 'Footer/Spacing/space-between-columns':
      return clsx(
        'gap-[40px]', // mobile
        'sm:gap-[40px]', // tablet
        'md:gap-[14px]' // desktop
      )
    case 'Footer/Spacing/space-between-buttons':
      return clsx(
        'gap-[16px]', // mobile
        'sm:gap-[8px]', // tabletmem
        'md:gap-[14px]' // desktop
      )
    case 'Header/Spacing/header-to-content':
      return clsx(
        'gap-[36px]', // mobile
        'sm:gap-[48px]', // tablet
        'md:gap-[64px]' // desktop
      )
    case 'Header/Spacing/space-between-horizontal':
      return clsx(
        'gap-[6px]', // mobile
        'sm:gap-[10px]', // tablet
        'md:gap-[16px]' // desktop
      )
    case 'Bento/Spacing/space-between':
      return clsx(
        'gap-[24px]', // mobile
        'sm:gap-[16px]', // tablet
        'md:gap-[24px]' // desktop
      )
    case 'Navigation Bar/Spacing/space-between-buttons':
      return clsx(
        'gap-[24px]', // mobile
        'sm:gap-[8px]', // tablet
        'md:gap-[12px]' // desktop
      )
    case 'Bento/Spacing/title-to-description':
      return clsx(
        'gap-[6px]', // mobile
        'sm:gap-[10px]', // tablet
        'md:gap-[16px]' // desktop
      )
    case 'Carousel/space-between':
      return clsx(
        'gap-[24px]', // mobile
        'sm:gap-[24px]', // tablet
        'md:gap-[24px]' // desktop
      )
    default:
      break
  }
}

export const padding = (name: PaddingType) => {
  switch (name) {
    case 'Footer/Spacing/padding':
      return clsx(
        'p-[12px]', // mobile
        'sm:p-[16px]', // tablet
        'md:p-[40px]' // desktop
      )
    case 'Breakpoints/top-bot-padding':
      return clsx(
        'py-[80px]', // mobile
        'sm:py-[80px]', // tablet
        'md:py-[120px]' // desktop
      )
    case 'Breakpoints/side-padding':
      return clsx(
        'px-[24px]', // mobile
        'sm:px-[32px]', // tablet
        'md:px-[24px]' // desktop
      )
    case 'Header/Spacing/top-bot':
      return clsx(
        'py-[4px]', // mobile
        'sm:py-[8px]', // tablet
        'md:py-[12px]' // desktop
      )
    case 'Header/Spacing/top-bot-t':
      return clsx(
        'pt-[4px]', // mobile
        'sm:pt-[8px]', // tablet
        'md:pt-[12px]' // desktop
      )
    case 'Header/Spacing/top-bot-b':
      return clsx(
        'pb-[4px]', // mobile
        'sm:pb-[8px]', // tablet
        'md:pb-[12px]' // desktop
      )
    case 'Header/Spacing/top-bot120-b':
      return clsx(
        'pb-[40px]', // mobile
        'sm:pb-[80px]', // tablet
        'md:pb-[120px]' // desktop
      )
    case 'Header/Spacing/icon-no':
      return clsx(
        'px-[14px]', // mobile
        'sm:px-[16px]', // tablet
        'md:px-[32px]' // desktop
      )
    case 'Button/Spacing/top-bot':
      return clsx(
        'py-[6px]', // mobile
        'sm:py-[10px]', // tablet
        'md:py-[12px]' // desktop
      )
    case 'Button/Spacing/left-right':
      return clsx(
        'px-[8px]', // mobile
        'sm:px-[12px]', // tablet
        'md:px-[16px]' // desktop
      )
    case 'Bento/Spacing/padding-S':
      return clsx(
        'p-[24px]', // mobile
        'sm:p-[24px]', // tablet
        'md:p-[32px]' // desktop
      )
    case 'Header/Spacing/left-right':
      return clsx(
        'pl-[4px]', // mobile
        'sm:pl-[8px]', // tablet
        'md:pl-[12px]' // desktop
      )
    case 'Header/Spacing/left-right-r':
      return clsx(
        'pr-[4px]', // mobile
        'sm:pr-[8px]', // tablet
        'md:pr-[12px]' // desktop
      )
    case 'Header/Spacing/left-right-l':
      return clsx(
        'pl-[4px]', // mobile
        'sm:pl-[8px]', // tablet
        'md:pl-[12px]' // desktop
      )
    case 'Header/Spacing/icon-left':
      return clsx(
        'pl-[4px]', // mobile
        'sm:pl-[8px]', // tablet
        'md:pl-[12px]' // desktop
      )
    case 'Header/Spacing/icon-left-l':
      return clsx(
        'pl-[24px]', // mobile
        'sm:pl-[24px]', // tablet
        'md:pl-[32px]' // desktop
      )
    case 'Header/Spacing/icon-left-r':
      return clsx(
        'pr-[24px]', // mobile
        'sm:pr-[24px]', // tablet
        'md:pr-[32px]' // desktop
      )
    case 'Tabs/Spacing/Tab/top-bot':
      return clsx(
        'py-[12px]', // mobile
        'sm:py-[8px]', // tablet
        'md:py-[14px]' // desktop
      )
    case 'Tabs/Spacing/Tab/left-right':
      return clsx(
        'px-[16px]', // mobile
        'sm:px-[14px]', // tablet
        'md:px-[24px]' // desktop
      )
    case 'Tabs/Spacing/Bar/top-bot':
      return clsx(
        'py-[16px]', // mobile
        'sm:py-[16px]', // tablet
        'md:py-[24px]' // desktop
      )
    case 'Tabs/Spacing/Bar/top-bot3':
      return clsx(
        'py-[0px]', // mobile
        'sm:py-[16px]', // tablet
        'md:py-[24px]' // desktop
      )
    case 'Tabs/Spacing/Bar/left-right':
      return clsx(
        'px-[8px]', // mobile
        'sm:px-[16px]', // tablet
        'md:px-[24px]' // desktop
      )
    case 'Tabs/Spacing/Bar/left-right48':
      return clsx(
        'px-[32px]', // mobile
        'sm:px-[40px]', // tablet
        'md:px-[48px]' // desktop
      )
    case 'Bento/Spacing/padding-M':
      return clsx(
        'p-[24px]', // mobile
        'sm:p-[24px]', // tablet
        'md:p-[32px]' // desktop
      )
    default:
      break
  }
}
